import LoaderTemplate from '../../html/components/loader.html'
import LoaderOverlayTemplate from '../../html/components/loader-overlay.html'

import Component from '../shared/component'

export const Loader = Component('v-loader', {
  template: LoaderTemplate,
  props: {
    size: {
      type: [Number, String],
      default: 14
    },
    label: {
      type: String
    }
  }
})

export const LoaderOverlay = Component('v-loader-overlay', {
  template: LoaderOverlayTemplate,
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    live: {
      type: Boolean,
      default: true
    },
    polite: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mask: null
    }
  },
  computed: {
    style () {
      return {
        minHeight: this.mask && this.loading ? this.mask.clientHeight + 'px' : null
      }
    }
  },
  mounted () {
    this.mask = this.$refs.mask
  }
})
